exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container {\n  font-family: Arial, sans-serif; }\n\n.question p {\n  font-size: 16px;\n  margin-bottom: 10px; }\n\n.answers {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap; }\n\n.answer {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-right: 15px;\n  font-size: 16px; }\n\n.answer span {\n  margin-right: 5px; }\n\n.mb-4 {\n  margin-bottom: 1.5rem; }\n\n.d-flex {\n  display: -ms-flexbox;\n  display: flex; }\n\n.flex-wrap {\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap; }\n\n.mr-3 {\n  margin-right: 1rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/quonta-intelligence/view-generated-paper/view-generated-paper.component.scss
// module id = ../../../../../src/app/parent/dashboard/pages/quonta-intelligence/view-generated-paper/view-generated-paper.component.scss
// module chunks = main